<template>
  <div>
    <div v-if="data.mask">
      <the-mask
        v-model="submit_data[data.key]"
        :style="data.style"
        v-bind="attrs"
        :placeholder="data.desc"
        size="default"
        :mask="data.mask"
        auto-complete="off"
        @blur="onBlur"
        @focus="onFocus"
        @keyup.enter="onKeyEnter"
        @change="onChange"
      />
    </div>

    <el-input
      v-if="data.mask === undefined && !data.isNumber"
      v-model="submit_data[data.key]"
      type="input"
      size="default"
      v-bind="attrs"
      :placeholder="data.desc"
      @blur="onBlur"
      @focus="onFocus"
      @keyup.enter="onKeyEnter"
      @change="onChange"
    />
    <el-input
      v-if="data.mask === undefined && data.isNumber"
      v-model.number="submit_data[data.key]"
      size="default"
      type="input"
      v-bind="attrs"
      :placeholder="data.desc"
      @blur="onBlur"
      @focus="onFocus"
      @keyup.enter="onKeyEnter"
      @change="onChange"
    />
  </div>
</template>
<script>
import Common from './js/Common';
import InputTextarea from './js/InputTextarea';

const Js = Common('sls-input');
Js.mixins = [InputTextarea];
export default Js;
</script>
<style scoped lang="less">
.el-input__inner {
    position: relative;
    font-size: 12px;
    display: inline-block;
    width: 100%;
}
</style>
